import { useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';

import usePermissionV2 from 'commons-ui/src/permission/usePermission';
import { IBankUpiHandleParams } from './actions/components/unsetBankAccount/model/bankUpiDetail.model';

const useBankAndUpiActions = (makeActionHandler: any, makeActionList: any, containerParams: IBankUpiHandleParams) => {
	const history = useHistory();
	const location = useLocation();
	const { app, showAlert } = useContext(AppContext);
	const { hasPermission: hasPermissionV2 } = usePermissionV2();
	const getBankAndUpiActionHandler = (action: any, params = EMPTY_OBJECT) => {
		return makeActionHandler(action, {
			...containerParams,
			...params,
			location,
			history,
			isGold: app.isGold,
			appName: app.appName,
			showAlert
		});
	};
	const getBankAndUpiActionList = (params = EMPTY_OBJECT) => {
		return makeActionList({
			...containerParams,
			...params,
			history,
			appName: app.appName,
			isGold: app.isGold,
			hasPermissionV2
		});
	};

	return {
		getBankAndUpiActionHandler,
		getBankAndUpiActionList
	};
};

export default useBankAndUpiActions;
